import { z } from 'zod/v4-mini';

import { GeneralBackendResponseSchema } from '$/services/mapper/authentication';
import { UserSchema } from '$/services/usecases/authentication/mapper/genericCloudResponse';

export const GetAllStudentsResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.array(UserSchema),
});

export const AcceptStudentInvitationResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.optional(z.object({ otpToken: z.string() })),
});
